import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { Heart, Users } from "lucide-react";
import { useLanguage } from "@/i18n/LanguageContext";
import Picture from "@/components/ui/picture";

const CTASection = () => {
  const { t } = useLanguage();
  return (
    <section className="relative py-20 md:py-28 overflow-hidden">
      <Picture src="/images/1270x710_29.png.jpg" alt="" width={1270} height={710} className="absolute inset-0 w-full h-full object-cover" loading="lazy" />
      <div className="absolute inset-0 avps-hero-overlay" />
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
        <div className="max-w-2xl mx-auto text-center">
          <h2 className="text-primary-foreground">{t.cta.title}</h2>
          <p className="mt-5 text-primary-foreground/80 text-base sm:text-lg leading-relaxed">{t.cta.text}</p>
          <div className="mt-8 flex flex-wrap gap-4 justify-center">
            <Button variant="cta" size="lg" asChild><Link to="/diventa-volontario"><Users className="w-5 h-5 mr-2" /> {t.cta.btn1}</Link></Button>
            <Button variant="hero-outline" size="lg" asChild><Link to="/sostienici"><Heart className="w-5 h-5 mr-2" /> {t.cta.btn2}</Link></Button>
          </div>
        </div>
      </div>
    </section>
  );
};

export default CTASection;
